/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React from 'react';
import { isNil } from 'lodash';
import classNames from 'classnames';
import IllustrationContainer from '../illustration/IllustrationContainer';
import { BOOK_TEMPLATE_TYPES } from '../../constants/book';
import { ITALIC_START, ITALIC_END, BOLD_START, BOLD_END, TRC_BREAK } from '../../constants/regExp';
import TRCButton from '../../trc/components/TRCButton';

const getParagraphs = (paragraphs, isTextHighlighted) =>
    paragraphs.map(paragraph => {
        const text = paragraph.text
            .replace(ITALIC_START, '<i>')
            .replace(ITALIC_END, '</i>')
            .replace(BOLD_START, '<b>')
            .replace(BOLD_END, '</b>')
            .replace(TRC_BREAK, '<br />');

        return [
            <React.Fragment key={`fragment-${paragraph.id}`}>
                {paragraph.header && <h3 key={`header-${paragraph.id}`}>{paragraph.header}</h3>}
                <div
                    key={`paragraph-wrapper-${paragraph.id}`}
                    className={classNames('paragraph-wrapper', { highlight: isTextHighlighted })}
                >
                    {/* TODO replace this implementation with non-dangerous way */}
                    <p
                        key={`paragraph-${paragraph.id}`}
                        dangerouslySetInnerHTML={{ __html: text }}
                    />
                </div>
            </React.Fragment>,
        ];
    });

const hasPicture = pictureAttributes => Object.keys(pictureAttributes).length !== 0;

const isPictureOnTopOfPage = template =>
    template === BOOK_TEMPLATE_TYPES.IMAGE_TOP_ONE_HALF ||
    template === BOOK_TEMPLATE_TYPES.IMAGE_TOP_TWO_THIRDS ||
    template === BOOK_TEMPLATE_TYPES.IMAGE_TOP_ONE_THIRD;

const Page = props => {
    const {
        pictureAttributes,
        template,
        pageNumber,
        paragraphs,
        indented,
        isTextHighlighted,
        onStopRecordingButtonClick,
    } = props;
    const getStyles = () => {
        const bookTemplateClass = template ? ` ${template}` : '';
        const indentation = indented ? ' indented' : '';
        return `book-page page-${bookTemplateClass}${indentation}`;
    };

    return (
        <div className={getStyles()}>
            {!isNil(template) && (
                <div>
                    <div className="pagenumber">{pageNumber}</div>
                    {hasPicture(pictureAttributes) && isPictureOnTopOfPage(template) && (
                        <IllustrationContainer key={`img-${pageNumber}`} {...pictureAttributes} />
                    )}
                    {getParagraphs(paragraphs, isTextHighlighted)}
                    {isTextHighlighted && (
                        <TRCButton
                            onClick={onStopRecordingButtonClick}
                            text="Stop recording"
                            styles="stop-recording-button"
                        />
                    )}
                    {hasPicture(pictureAttributes) && !isPictureOnTopOfPage(template) && (
                        <IllustrationContainer key={`img-${pageNumber}`} {...pictureAttributes} />
                    )}
                </div>
            )}
        </div>
    );
};

Page.propTypes = {
    template: PropTypes.oneOf([
        BOOK_TEMPLATE_TYPES.FULL_PAGE,
        BOOK_TEMPLATE_TYPES.IMAGE_TOP_ONE_HALF,
        BOOK_TEMPLATE_TYPES.IMAGE_BOTTOM_ONE_HALF,
        BOOK_TEMPLATE_TYPES.IMAGE_TOP_ONE_THIRD,
        BOOK_TEMPLATE_TYPES.IMAGE_BOTTOM_ONE_THIRD,
        BOOK_TEMPLATE_TYPES.IMAGE_TOP_TWO_THIRDS,
        BOOK_TEMPLATE_TYPES.IMAGE_BOTTOM_TWO_THIRDS,
    ]),
    paragraphs: PropTypes.arrayOf(
        PropTypes.shape({
            header: PropTypes.string,
            text: PropTypes.string.isRequired,
            id: PropTypes.string.isRequired,
        }),
    ),
    pictureAttributes: PropTypes.object,
    pageNumber: PropTypes.number,
    indented: PropTypes.bool,
    isTextHighlighted: PropTypes.bool,
    onStopRecordingButtonClick: PropTypes.func,
};

Page.defaultProps = {
    paragraphs: [],
    template: undefined,
    pictureAttributes: {},
    pageNumber: undefined,
    indented: false,
    isTextHighlighted: false,
    onStopRecordingButtonClick: () => {},
};

export default Page;
